import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FacturaModel } from 'src/app/domain/models/factura/factura.model';
import { FacturaUseCase } from 'src/app/domain/usecases/factura/factura.usecase';

@Component({
  selector: 'app-facturas-table',
  templateUrl: './facturas-table.component.html',
  styleUrls: ['./facturas-table.component.css']
})
export class FacturasTableComponent {
  @Input()
  data: FacturaModel | undefined;

  @Output() dataTableEvent = new EventEmitter<[number, number]>();

  actions: any[] = [
    { icon: 'download-document', text: 'EXPORTAR', id: 'export' },
    { icon: 'remove', text: 'ELIMINAR', id: 'delete' },
    { icon: 'house', text: 'PRUEBA', id: 'prueba' },
  ];

  constructor(
    private facturaUseCase: FacturaUseCase) { }


  onChangePage(data: any) {
    this.dataTableEvent.emit([(data.CurrentPage - 1), data.PerPage]);
  }

  procesarCss(tipo: string): string {
    return this.facturaUseCase.procesarCssTable(tipo);
  }

  optionSelectedScroll(data: any) {
    if (data.optionSeleted === 'lock') {
      data.rowData.status = 'disabled';
    } else {
      data.rowData.status = 'active';
    }
  }
}
